import React from "react";
import "../CSS/Footer.css";
import { FaInstagram, FaXTwitter, FaYoutube, FaLinkedin } from "react-icons/fa6";

const Footer = () => {
  return (
     <footer className="footer">
      <div className="footer-container">
        {/* Logo dan bagian kiri */}
        <div className="footer-left">
          <div className="logo-footer">
            <img src="/assets/logobaruTibiSmartW.png" alt="TibiSmart Logo" />
          </div>
    
          {/* wrap navigasi*/}
          <div className="footer-links">
            <div className="footer-section">
              <h4>Navigation</h4>
              <ul>
                <li>About</li>
                <li>Help</li>
                <li>Contact</li>
              </ul>
            </div>
    
            <div className="footer-section">
              <h4>Information</h4>
              <ul>
                <li>+62-8765-7896-4000</li>
                <li>tibismart@gmail.com</li>
              </ul>
            </div>
          </div>
        </div>
    
        {/* Sosial media */}
        <div className="footer-right">
          <h4>Ikuti Kami</h4>
          <div className="social-icons">
            <FaInstagram />
            <FaXTwitter />
            <FaYoutube />
            <FaLinkedin />
          </div>
        </div>
      </div>
    
      <hr />
      <p className="footer-copy">© 2025 TibiSmart. All rights reserved.</p>
    </footer>
    
    
  );
};

export default Footer;
